<app-form-page [config]="config" [drillDown]="false"></app-form-page>
